import {
  SET_REQUIRED_FIELDS_FILTERS,
  RESET_REQUIRED_FIELDS_FILTERS,
  SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setRequiredFieldsFilters = filters => ({
  type: SET_REQUIRED_FIELDS_FILTERS,
  filters,
});

export const cleanRequiredFieldsFilters = () => ({
  type: RESET_REQUIRED_FIELDS_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA,
  sortCriteria,
});
